import { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";

interface BaseDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
}

export const BaseDialog = ({
  open,
  onOpenChange,
  title,
  children,
}: BaseDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        onOpenAutoFocus={(e) => e.preventDefault()}
        className="max-w-[350px] lg:max-w-[500px] rounded-[4px] border-black/[0.09] p-6 gap-6 shadow-[0px_8px_16px_0px_rgba(0,0,0,0.09),0px_0px_36px_0px_rgba(0,0,0,0.11)]"
      >
        <DialogTitle className="text-2xl font-semibold leading-8 tracking-[-0.02em] text-[#000000]">
          {title}
        </DialogTitle>
        {children}
      </DialogContent>
    </Dialog>
  );
};
